export const businessVars = Object.freeze({
    PREFFIX_PHONE: "549"
});